import { render, staticRenderFns } from "./dish-settings.vue?vue&type=template&id=1d6ea34a&"
import script from "./dish-settings.vue?vue&type=script&lang=ts&"
export * from "./dish-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports